import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignIsPublicReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isPublic = action.payload;
};

export default setDesignIsPublicReducer;
